// extracted by mini-css-extract-plugin
module.exports = {"RecaptchaHandler":"styles_RecaptchaHandler__kL0nT","marker":"styles_marker__MNiHY"};